/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Removed_SuccessInputs */



/**
* | output |
* | --- |
* | "Group was successfully removed" |
*
* @param {Team_Manager_Group_Removed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_removed_success = /** @type {((inputs?: Team_Manager_Group_Removed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Removed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe supprimé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Gruppe wurde erfolgreich entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo è stato rimosso con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа была успешно удалена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo fue eliminado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该组已成功移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह को सफलतापूर्वक हटा दिया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo foi removido com sucesso.")
	return /** @type {LocalizedString} */ ("Group was successfully removed")
});